import { FC } from 'react';
import {
	CodeBlock as CodeBlockLib,
	monokai,
	CopyBlock as darkTheme,
} from 'react-code-blocks';
import './CodeRow.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

type CodeRowProps = {
	row: string;
	language?: string;
	withTheme?: boolean;
};

const CodeRow: FC<CodeRowProps> = ({ row, language, withTheme }) => {
	const { isDarkTheme } = useSelector((state: RootState) => state.ui.theme);
	const theme = isDarkTheme ? monokai : darkTheme;
	return (
		<div className="independent-code-block">
			<CodeBlockLib
				language={language || 'text'}
				text={row}
				showLineNumbers={false}
				theme={withTheme ? theme : monokai}
			/>
		</div>
	);
};

export default CodeRow;
